<template>
  <div class="container">
      <div class="topView">
           <div class="topView_top">
                <div class="topView_top_left">
                    <div class="topView_top_left_top">
                        <img class="topView_top_left_top_img" :src="require(`../../assets/images/approve/icon_approve_company_${common.theme}.png`)"/>
                        <span class="topView_top_left_top_span">企业认证</span>
                    </div>
                    <span class="topView_top_left_bottom">{{createTime | formatTime}}</span>
                </div>
                <img v-if="status==1" class="topView_top_Right" src="../../assets/images/icon_audit_passed.png"/>
                <img v-if="status==2" class="topView_top_Right" src="../../assets/images/icon_audit_failed.png"/>
           </div>
           <div class="topView_item">
               <span class="topView_item_left">申请人</span>
               <span class="topView_item_right">{{userName}}</span>
           </div>
            <div class="topView_item">
               <span class="topView_item_left">手机号</span>
               <a class="topView_item_right blue" :href="'tel:'+phone" :phone="phone">{{phone}}</a>
           </div>
           <div class="topView_item" v-if="email">
               <span class="topView_item_left">邮箱</span>
               <span class="topView_item_right">{{email}}</span>
           </div>
           <div class="topView_line"></div>
           <div class="topView_item">
               <span class="topView_item_left">项目</span>
               <span class="topView_item_right">{{marketName}}</span>
           </div>
           <div class="topView_item">
               <span class="topView_item_left">公司</span>
               <span class="topView_item_right">{{company}}</span>
           </div>
           <div class="topView_item" v-if="department">
               <span class="topView_item_left">部门</span>
               <span class="topView_item_right">{{department}}</span>
           </div>
      </div>
      <div class="shenpi_person" v-if="approvalUser" >
            <span class="topView_item_left">审批人</span>
            <span class="topView_item_right">{{approvalUser}}</span>
      </div>
      <div class="roleSelect" v-if="status==1 &&roleSelectData1.length>0">
          <span class="roleSelect_title">授权范围</span>
          <div class="roleSelect_div">
              <div class="roleSelect_item" v-for="item in roleSelectData1" :key="item.name">
                  <span class="roleSelect_item_span">{{item.name}}</span>
                  <img class="roleSelect_item_icon" src="../../assets/images/icon_select_xiabiao.png"/>
              </div>
          </div>
      </div>
      <div class="foot" v-if="status==0">
          <span class="footSpan">{{userName}}申请认证到贵公司，请核实信息并尽快处理，警惕错误操作有可能为您的公司带来风险</span>
          <div class="footdiv button">
              <span class="foot_button_1 btn_primary"  @click="enableUserTenant(2)">拒绝</span>
              <span class="foot_button_2 btn_default"  @click="enableUserTenant(1)">通过</span>
          </div>
      </div>
      <!-- 自己不能修改自己的权限 如果是自己 不显示按钮 -->
      <div class="footButton" v-if="status==1 &&roleList.length>0 &&common.userId!=userID">
          <div class="footButton_div1" @click="lizhiAlert">
               <span class="footButton_span1">离职处理</span>
          </div>
          <div class="footButton_div1" v-if="roleSelectData1.length==0" @click="showPopupAction()">
              <span class="footButton_span1">授权</span>
          </div>
           <div class="footButton_div1" v-else @click="showPopupAction()">
              <span class="footButton_span1">修改授权</span>
          </div>
      </div>
       <mt-popup v-model="showPopup" position="bottom" class="mint-popup">
            <div class="editRolepopup">
                <div class="editRoleTop">
                    <span class="editRoleTop_span1" @click="hidePopup()">取消</span>
                    <span class="editRoleTop_span2">授权范围(多选)</span>
                    <span class="editRoleTop_span3" @click="savePermissionAction()">确认</span>
                </div>
                <div class="editRoleList">
                     <scroll :pullup="false" :pulldown="false" :scrollX="true"  >
                         <div class="editRoleListView"  >
                             <div :class="[item.isCheck==1?'editRoleListItem':'editRoleListItem1']" v-for="(item,index) in editRoleList" :key="index" @click="changeRole(item)" >
                                 <span class="editRoleListItem_span">{{item.name}}</span>
                                 <img class="editRoleListItem_icon" v-if="item.isCheck==1" src="../../assets/images/icon_select_xiabiao.png"/>
                             </div>
                         </div>
                     </scroll>
                </div>
            </div>
       </mt-popup>
 </div>
 </template>
<script>
import { mapState } from 'vuex';
import { enableUserTenant,getUserTenantDetail ,companyRoleList,savePermission,getRoleInfos } from "../../utils/api";
import util from '../../utils/util';
import Scroll from "../../components/scroll";

export default {
  name: "approvalDetail",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
   components: {
     Scroll,
  },

  filters: {

    formatTime(val){
      return util.formatTime(new Date(val),10)
    }
  },
  data() {
    return {
        id: '',
        createTime: '',
        userName: '',
        showPopup:false,
        phone: '',
        email: '',
        marketName:"",
        company: '',
        approvalUser:'',
        department: '',
        status: '',
        result: '',
        roleList:"", //接口返回的所有权限
        roleSelectData:"", //当前用户有的权限
        editRoleList:"", //用来编辑的数据
        userID:'',     //被授权人的用户id
        photoPath: '',
        roleList1:"", //接口返回的所有权限
        roleSelectData1:"", //当前用户有的权限
    }
  },

  created() {

    //   this.createTime = Number(query.createTime)
    //   this.userName = decodeURI(query.userName)
    //   this.phone = query.phone
    //   this.email = query.email || ''
    //   if(this.email==undefined ||this.email=="undefined"){
    //       this.email='';
    //   }
    //   this.marketName = decodeURI(query.marketName)
    //   this.company = decodeURI(query.company)
    //   this.approvalUser = query.approvalUser==''||query.approvalUser=='undefined'?'':decodeURI(query.approvalUser)
    //   if(this.approvalUser==undefined ||this.approvalUser=="undefined"){
    //       this.approvalUser='';
    //   }
    //   this.department = query.department==''||query.department=='undefined'?'':decodeURI(query.department)
    //   if(this.department==undefined ||this.department=="undefined"){
    //       this.department='';
    //   }
    //   this.status = query.status
    //   this.photoPath = query.photoPath
    //   console.log(this.common.userInfo)
  },
  activated () {
      let query = this.$route.query;
      this.id = query.id
      this.getUserTenantDetail();
      this.getCompanyRoleList();
      this.getRoleInfos();
  },
  methods: {
      hidePopup(){
          this.showPopup=false;
      },
      showPopupAction(){
          this.editRoleList =this.roleList
          this.showPopup=true;
      },
      changeRole(item){
          for(var i=0;i<this.editRoleList.length;i++){
              var vItem=this.editRoleList[i];
              if(vItem.id ==item.id){
                   if(vItem.isCheck==1){
                        vItem.isCheck =0;
                    }else{
                        vItem.isCheck=1;
                    }
              }
          }
      },
      getUserTenantDetail(){
          getUserTenantDetail({
            id: this.id,
          }).then(res => {
              console.log(res);
            if (res.res.code === 10000) {
               let userTenant = res.body.userTenant;
               this.createTime = Number(userTenant.createTime)
               this.userName = userTenant.userName
               this.userID =userTenant.userId
                this.phone = userTenant.phone
                this.email = userTenant.email || ''
                if(this.email==undefined ||this.email=="undefined"){
                    this.email='';
                }
                this.marketName = userTenant.marketName
                this.company = userTenant.company
                this.approvalUser = userTenant.approvalUser || ''
                if(this.approvalUser==undefined ||this.approvalUser=="undefined"){
                    this.approvalUser='';
                }
                this.department = userTenant.department==''||userTenant.department=='undefined'?'':userTenant.department
                if(this.department==undefined ||this.department=="undefined"){
                    this.department='';
                }
                this.status = userTenant.status
                console.log("this.status ====  " +this.status)
                this.photoPath = userTenant.photoPath
            }else{
                util.showToast(res.res.msg)
            }
          })
      },

       enableUserTenant: function(status) {
           util.showLoading('处理中...')
            enableUserTenant({
            id: this.id,
            status: status,
            marketId:  this.common.marketInfo.id,
            }).then(res => {
                if (res.res.code === 10000) {
                    this.status =status;
                    // if(this.common.userInfo.name){
                    //     this.approvalUser = this.common.userInfo.name
                    // }else{
                        this.approvalUser = this.common.userTenantInfo.userName || this.common.userInfo.userName
                    //}
                    if(status==3){
                        this.$router.go(-1);
                    }else{
                        this.getCompanyRoleList();
                        this.getRoleInfos();
                    }
                }
                util.hideLoading()
            })
        },
      //被授权用户所有权限
      getRoleInfos(){
           let params = {
                pageSize: 100,
                pageNumber: 1,
                id: this.id
            }
            getRoleInfos(params).then(res => {
                console.log(res)
                if (res.res.code === 10000) {
                    this.roleList1 = res.body.allPermission;
                    var rolePermission =res.body.RolePermission;
                    // var list1=[];
                    for(var i=0;i<this.roleList1.length;i++){
                        var vitem =this.roleList1[i];
                        for(var j=0;j<rolePermission.length;j++){
                            var jitem =rolePermission[j];
                            if(vitem.id==jitem.roleId){
                                vitem.isCheck=1;
                            }
                        }
                    }
                    this.roleSelectData1 =  this.roleList1.filter(item => {
                        return item.isCheck === 1
                    })
                }
            })

      },
      //获取授权列表
      getCompanyRoleList(){
          let params = {
            pageSize: 100,
            pageNumber: 1,
            id: this.id
        }
        companyRoleList(params).then(res => {
            console.log(res)
            if (res.res.code === 10000) {
                this.roleList = res.body.roleList
                this.roleSelectData = res.body.roleList.filter(item => {
                    return item.isCheck === 1
                })
            } else {
               // util.showToast('error', res.res.msg)
            }
            // setTimeout(() => {
            //   this.role_loading = false
            // }, 100)
        })
      },
      //授权
      savePermissionAction(){
          let roleIds = []
          let ids = []
          this.editRoleList.forEach(item => {
                if (item.isCheck === 1) {
                roleIds.push(item.id)
                }
         })
        //  console.log(this.selectData)
        //  this.selectData.forEach(item => {
            ids.push(this.id)
         //})
        let params = {
            ids: ids.join(','),
            roleIds: roleIds.join(',')
        }
        savePermission(params).then(res => {

            if (res.res.code === 10000) {
                 this.showPopup = false
                util.showToast('授权成功')
                this.getCompanyRoleList()
                this.getRoleInfos();
            }else{
                 util.showToast(res.res.msg);
            }
        })

      },

      lizhiAlert(){
        util.showModal('','操作后将取消该员工的认证并删除其相关权限',true,'确定',()=>{
            this.lizhiAction();
        })
      },
      lizhiAction(){
          this.enableUserTenant(3)
      }

  },
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
//   height: 100vh;
  background-color: #EEEEEE;
  .flex(column);
}

.topView{
    flex-direction: column;
    margin: 28px 20px;
    // height: 710px;
    background-color: #ffffff;
    border-radius:8px;
}

.topView_top{
    height: 120px;
    margin-top: 28px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

}

.topView_top_left{
     display: flex;
     margin-top: 12px;
     flex-direction:column;
     margin-left: 40px;
     width: 96px;
     width: 500px;
    //  display: flex;
}

.topView_top_Right{
    width: 120px;
    height: 120px;
    display: flex;
    margin-right: 28px;
}

.topView_top_left_top{
    flex-direction:row;
    width: 500px;
    display: flex;
}
.topView_top_left_top_img{
    width:44px ;
    height: 44px;
    display: flex;
}
.topView_top_left_top_span{
    margin-left: 20px;
    height:44px;
    font-size:32px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.topView_top_left_bottom{
    display: flex;
    margin-top: 20px;
    height:34px;
    font-size:24px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:34px;

}

.topView_item{
    height: 78px;
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.topView_item_left{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;

}

.topView_item_right{
    margin-right: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.blue{
    color:#1740DA
}

.topView_line{
   margin:5px 40px;
   height:2px;
   background-color:rgba(234,234,234,1);
}


.shenpi_person{
    margin:0 20px;
    background-color: #ffffff;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius:8px;
}

.foot{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:100;
    height: 224px;
    display: flex;
    background-color: white;
    flex-direction: column;
}

.footSpan{
    margin-top: 28px;
    margin-left: 40px;
    width:670px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:34px;
}

.footdiv{
    margin-top: 40px;
    width:100%;
    flex-direction: row;
    display: flex;
    justify-content: space-between;

}
.foot_button_1{
    margin-left: 32px;
    width:332px;
    height:68px;
    border-radius:4px;
    border:2px solid rgba(23,64,218,1);
    font-size:28px;
    font-weight:400;
    color:rgba(23,64,218,1);
    line-height:68px;
    text-align: center;
}
.foot_button_2{
    margin-right: 32px;
    width:332px;
    height:68px;
    border-radius:4px;
    background-color: #1740DA;
    .border(rgba(23,64,218,1));
    font-size:28px;
    font-weight:400;
    color:#ffffff;
    line-height:68px;
    text-align: center;

}


.footButton{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:100;
    height: 120px;
    padding:26px 32px;
    box-sizing:border-box;
    display: flex;
    background-color: white;
    flex-direction: row;
    justify-content: space-between;
}
.footButton_div{
    width:332px;
    height:76px;
    background:rgba(23,64,218,1);
    border-radius:4px;
    display: flex;
    justify-content: center;
    align-items: center;
    .footButton_span{
        height:44px;
        font-size:32px;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:44px;
    }

}
.footButton_div1{
    width:332px;
    height:68px;
    border-radius:4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border:2px solid rgba(23,64,218,1);
    .footButton_span1{
        height:44px;
        font-size:28px;
        font-weight:400;
        color:rgba(23,64,218,1);
        line-height:44px;
    }
}


.roleSelect{
    display: flex;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 120px;
    padding-bottom: 40px;
    background:rgba(255,255,255,1);
    border-radius:8px;
    flex-direction: column;
}
.roleSelect_title{
    display: flex;
    margin-top: 30px;
    margin-left: 40px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;

}
.roleSelect_div{
    margin-top: 8px;
    margin-left: 40px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .roleSelect_item{
        margin-top: 20px;
        width:306px;
          display: flex;
        height:76px;
        background:rgba(248,248,248,1);
        border-radius:4px;
        margin-right: 20px;
        position: relative;
        .roleSelect_item_span{
             width:306px;
             text-align: center;
            height:76px;
            font-size:26px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:76px;
        }
        .roleSelect_item_icon{
            width: 36px;
            height: 36px;
            position: absolute;
            right: 0;
            bottom: 0;

        }
    }

}
//popup
.editRolepopup{
    width:100%;
    height:640px;
    background:rgba(255,255,255,1);
    flex-direction: column;
    .editRoleTop{
      width:100%;
      height:640px;
      display: flex;
      height:88px;
      background:rgba(248,248,248,1);
      flex-direction: row;
      .editRoleTop_span1{
          margin-top: 22px;
          margin-left: 28px;
          height:42px;
          font-size:30px;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:42px;
      }
      .editRoleTop_span2{
          margin-top: 22px;
          margin-left: 180px;
          margin-right: 180px;
          height:44px;
         font-size:32px;
         font-weight:500;
         color:rgba(51,51,51,1);
         line-height:44px;
      }
      .editRoleTop_span3{
          margin-top: 22px;
          height:42px;
         font-size:30px;
         font-weight:500;
         color:rgba(23,64,218,1);
         line-height:42px;
      }
    }

    .editRoleList{
        width: 100%;
        height: 552px;
        .editRoleListView{
            margin-left: 28px;
            margin-top: 28px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .editRoleListItem{
                width:336px;
                height:76px;
                display: flex;
                border-radius:4px;
                border:2px solid #1740DA;
                margin-right: 20px;
                margin-bottom: 20px;
                position: relative;
                .editRoleListItem_span{
                     width:336px;
                    text-align: center;
                    height:76px;
                    font-size:26px;
                    font-weight:400;
                    color:#1740DA;
                    line-height:76px;
                }
                .editRoleListItem_icon{
                     width: 36px;
                    height: 36px;
                    position: absolute;
                    right: 0;
                    bottom: 0;

                }

            }
            .editRoleListItem1{
                width:336px;
                height:76px;
                border-radius:4px;
                border:2px solid rgba(218,218,218,1);
                margin-right: 20px;
                margin-bottom: 20px;
                 display: flex;
                position: relative;
                .editRoleListItem_span{
                     width:336px;
                    text-align: center;
                    height:76px;
                    font-size:26px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:76px;

                }
                .editRoleListItem_icon{
                     width: 36px;
                    height: 36px;
                    position: absolute;
                    right: 0;
                    bottom: 0;

                }

            }

        }
    }

}


</style>